import styled from 'styled-components';

// CONSTANTS
import { SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div``;

export const CarouselWrapper = styled.div`
  .card-wrapper {
    &--see-all {
      .dummy-card {
        position: relative;
        border-radius: 12px;
        padding-top: 190px;

        &__content {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          i {
            font-size: 36px;
            color: ${SANTAS_GRAY};
            margin-bottom: 20px;
          }

          span {
            color: ${p => p.theme.palette.text.primary};
          }
        }
      }
    }
  }

  .stage-carousel {
    padding-top: 0;

    .swiper-slide {
      width: 256px;
      max-width: 256px;
    }

    ${breakpoints.down('md')} {
      .swiper-button-nav {
        display: none;
      }
    }

    ${breakpoints.up('lg')} {
      .swiper-button-nav {
        transform: translateY(0);
      }
    }
  }
`;

export default Container;
